export { WEB_CLIENT_ID } from './google.client';
